import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { CentralBillingUnitModuleModel } from '../central-billing-unit-module.model';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-billing-central-view',
    templateUrl: './billing-central-view.component.html',
    styleUrls: ['./billing-central-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-central-view' },
    standalone: false,
})
export class BillingCentralViewComponent implements OnInit {
    @Input() businessUnitModule: CentralBillingUnitModuleModel;
    editTabs: EditTabsModel;

    constructor(
        private fiStateService: FiStateService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(this.businessUnitModule.ModuleTypeName, this.appTextService.get('back'));
    }

    editCentralBilling() {
        this.fiStateService.go(FiStateNames.Billing.Central.Edit, {
            ModuleType: this.businessUnitModule.ModuleType,
        });
    }
}
